require('../proposals/global-this');
require('../proposals/promise-all-settled');
require('../proposals/string-match-all');

module.exports = require('../internals/path');
